import { localStorage } from '@change-corgi/core/storage';

import { parsePendingSignature } from '#src/app/shared/utils/signature';

type ConsentInput = {
	consentGiven: boolean;
	name: string;
	text: string;
};

// TODO: extract this and src/app/pages/petition/details/hooks/signPetition/localStoredPendingSignature/index.ts to a shared hook folder to co-locate typings, etc
export function getConsentInputFromPendingSigInLocalStorage(petitionId: string): ConsentInput | undefined {
	// TODO use usePendingSignature() shared hook
	const pendingSignature = parsePendingSignature(localStorage.getItem(`pending-signature-${petitionId}`));

	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
	if (pendingSignature?.formData?.marketing_comms_consent) {
		return {
			consentGiven: pendingSignature.formData.marketing_comms_consent,
			name: pendingSignature.formData.consent_name,
			text: pendingSignature.formData.consent_text,
		};
	}

	return undefined;
}
